<template>
    <div class="all-release" >
        <div class="home-pages-tabs">    
        <b-card title="Card Title" no-body>
        <b-tabs pills card >
            <b-tab active>
            <template v-slot:title>
                <i class="fa fa-minus-square"></i> <strong>Despesas</strong>
            </template>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Data Início:" 
                            label-for="release-search-start_date">
                        <b-form-input 
                            id="release-search-start_date" 
                            type="date"
                            v-model="start_date_payment" 
                            size="lg"
                        />
                        </b-form-group>
                    </b-col>   
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Data Término:" 
                            label-for="release-search-end_date">
                            <b-form-input 
                            id="release-search-end_date" 
                            type="date"
                            v-model="end_date_payment" 
                            size="lg"
                            />
                        </b-form-group>
                    </b-col> 
                    <b-col md="3" sm="12">
                        <b-button 
                            pill size="sm" 
                            title="Pesquisar" 
                            class="mt-4 mb-4 fa fa-search" 
                            @click="[loadReleasesPayments(),toggleBusyPayment()]" 
                            variant="outline-secondary" 
                        >
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>             
                <b-col md="12" sm="12"> 
                <transition  name="slide" type="animation" appear>       
                <b-table 
                    :busy="isBusyPayment"   
                    class="table-responsive" 
                    hover 
                    key="slide" 
                    striped 
                    :items="release_payments" 
                    :fields="fieldsReleasePayment">
                    <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button 
                            pill 
                            title = "Excluir registro" 
                            size="sm" 
                            variant="outline-danger"  
                            @click="[showMsgBoxCancelPayment(data.item)]" 
                            class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>  
                </b-table>    
                </transition>
                 <b-pagination
                        v-model="currentPage"
                        :total-rows="rowsPayment"
                        :per-page="perPage"
                        pills
                        aria-controls="my-table"
                    ></b-pagination> 
              </b-col>           
              </b-row>
            </b-tab>

            <b-tab>
            <template v-slot:title>
                <i class="fa fa-plus-square"></i> <strong>Receitas</strong>
            </template>
              <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Data Início:" 
                            label-for="release-recipe-search-start_date">
                        <b-form-input 
                            id="release-recipe-search-start_date" 
                            type="date"
                            v-model="start_date_recipe" 
                            ref="inputsearch"
                            size="lg"
                        />
                        </b-form-group>
                    </b-col>   
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Data Término:" 
                            label-for="release-recipe-search-end_date">
                            <b-form-input 
                            id="release-recipe-search-end_date" 
                            type="date"
                            v-model="end_date_recipe" 
                            size="lg"
                            />
                        </b-form-group>
                    </b-col> 
                    <b-col md="3" sm="12">
                        <b-button 
                            pill size="sm" 
                            title="Pesquisar" 
                            class="mt-4 mb-4 fa fa-search" 
                            @click="[loadReleasesRecipes(),toggleBusyRecipe()]" 
                            variant="outline-secondary" 
                        >
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>             
                <b-col md="12" sm="12"> 
                <transition  name="slide" type="animation" appear>       
                <b-table 
                    :busy="isBusyRecipe"   
                    class="table-responsive" 
                    hover key="slide" 
                    striped 
                    :items="release_recipes" 
                    :fields="fieldsReleaseRecipe">
                     <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                         <b-button 
                            pill 
                            title = "Excluir registro" 
                            size="sm" 
                            variant="outline-danger"  
                            @click="[showMsgBoxCancelRecipe(data.item)]" 
                            class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>  
                </b-table>    
                </transition>
                 <b-pagination
                        v-model="currentPage"
                        :total-rows="rowsRecipe"
                        :per-page="perPage"
                        pills
                        aria-controls="my-table"
                    ></b-pagination> 
              </b-col>           
              </b-row>
            </b-tab>
            <b-tab>
            <template v-slot:title>
                <i class="fa fa-dashboard"></i> <strong>Abastecimentos</strong>
            </template>
                 <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Data Início:" 
                            label-for="supplycontrol-search-start_date">
                        <b-form-input 
                            id="supplycontrol-search-start_date" 
                            type="date"
                            v-model="start_date_supllycontrol" 
                            size="lg"
                        />
                        </b-form-group>
                    </b-col>   
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Data Término:" 
                            label-for="supplycontrol-search-end_date">
                            <b-form-input 
                            id="supplycontrol-search-end_date" 
                            type="date"
                            v-model="end_date_supplycontrol" 
                            size="lg"
                            />
                        </b-form-group>
                    </b-col> 
                    <b-col md="3" sm="12">
                        <b-button 
                            pill size="sm" 
                            title="Pesquisar" 
                            class="mt-4 mb-4 fa fa-search" 
                            @click="[loadSupplyControls(),toggleBusySupplyControl()]" 
                            variant="outline-secondary" 
                        >
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>             
                <b-col md="12" sm="12"> 
                <transition  name="slide" type="animation" appear>       
                <b-table 
                    :busy="isBusySupplyControl"   
                    class="table-responsive" 
                    hover 
                    key="slide" 
                    striped 
                    :items="supplycontrols" 
                    :fields="fieldsSupplyControl">
                    <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button 
                            pill 
                            title = "Excluir registro" 
                            size="sm" 
                            variant="outline-danger"  
                            @click="[showMsgBoxCancelSupplyControl(data.item)]" 
                            class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>  
                </b-table>    
                </transition>
                 <b-pagination
                        v-model="currentPage"
                        :total-rows="rowsPayment"
                        :per-page="perPage"
                        pills
                        aria-controls="my-table"
                    ></b-pagination> 
              </b-col>           
              </b-row>
            </b-tab>
            <b-tab>
            <template v-slot:title>
                <i class="fa fa-dot-circle-o"></i> <strong>Troca de Pneu</strong>
            </template>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Data Início:" 
                            label-for="tiremoviment-search-start_date">
                        <b-form-input 
                            id="tiremoviment-search-start_date" 
                            type="date"
                            v-model="start_date_tiremoviment" 
                            size="lg"
                        />
                        </b-form-group>
                    </b-col>   
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Data Término:" 
                            label-for="tiremoviment-search-end_date">
                            <b-form-input 
                            id="tiremoviment-search-end_date" 
                            type="date"
                            v-model="end_date_tiremoviment" 
                            size="lg"
                            />
                        </b-form-group>
                    </b-col> 
                    <b-col md="3" sm="12">
                        <b-button 
                            pill size="sm" 
                            title="Pesquisar" 
                            class="mt-4 mb-4 fa fa-search" 
                            @click="[loadTireMoviments(),toggleBusyTireMoviment()]" 
                            variant="outline-secondary" 
                        >
                        </b-button>
                    </b-col>
                </b-row>
                  <b-row>             
                <b-col md="12" sm="12"> 
                <transition  name="slide" type="animation" appear>       
                <b-table 
                    :busy="isBusyTireMoviment"   
                    class="table-responsive" 
                    hover 
                    key="slide" 
                    striped 
                    :items="tiremoviments" 
                    :fields="fieldsTireMoviment">
                    <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                         <b-button 
                            pill 
                            title = "Excluir registro" 
                            size="sm" 
                            variant="outline-danger"  
                            @click="showMsgBoxCancelTireMoviment(data.item)" 
                            class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>  
                </b-table>    
                </transition>
                 <b-pagination
                        v-model="currentPage"
                        :total-rows="rowsTireMoviment"
                        :per-page="perPage"
                        pills
                        aria-controls="my-table"
                    ></b-pagination> 
              </b-col>           
              </b-row>
            </b-tab>
        </b-tabs>    
                
        </b-card>
        </div>
    </div>
</template>

<script>

import { baseApiUrl,showError } from '@/global'
import axios from 'axios'
var moment = require('moment')

export default {
    name: 'Home',
    components:{},
    data: function(){
        return {
          release_payments: [],
          release_recipes: [],
          supplycontrols:[],
          tiremoviments:[],
          company_id: null,
          start_date_payment: null,
          end_date_payment: null,
          start_date_recipe: null,
          end_date_recipe: null,
          start_date_supllycontrol: null,
          end_date_supplycontrol: null,
          start_date_tiremoviment: null,
          end_date_tiremoviment: null,
          perPage: 5,
          currentPage: 1,
          isBusyPayment: false,
          isBusyRecipe: false,
          isBusySupplyControl: false,
          isBusyTireMoviment: false,
          fieldsReleasePayment: [
               { key: 'release_date', label: 'Data Emissão', sortable: true,variant: 'primary',
                   formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '') },  
                { key: 'internal_code_equipment', label: 'Equipamento', sortable: true },
                { key: 'name_entity', label: 'Fornecedor', sortable: false },  
                { key: 'release_value', label: 'Valor', sortable: false }, 
                { key: 'actions', label: 'Ações', variant: 'light' }

          ],
         fieldsReleaseRecipe: [
               { key: 'release_date', label: 'Data Emissão', sortable: true,variant: 'primary',
                   formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '') },  
                { key: 'internal_code_equipment', label: 'Equipamento', sortable: true },
                { key: 'name_entity', label: 'Cliente', sortable: false },  
                { key: 'release_value', label: 'Valor', sortable: false }, 
                { key: 'actions', label: 'Ações', variant: 'light' }

          ],
          fieldsSupplyControl: [
               { key: 'supply_date', label: 'Abastecimento em', sortable: true,variant: 'primary',
                   formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '') },  
                { key: 'internal_code_equipment', label: 'Equipamento', sortable: true },
                { key: 'note_control_value', label: 'Km/H.', sortable: false },  
                { key: 'quantity', label: 'Qtde.', sortable: false }, 
                { key: 'total_value', label: 'Total', sortable: false }, 
                { key: 'actions', label: 'Ações', variant: 'light' }

          ],
          fieldsTireMoviment: [
               { key: 'moviment_date', label: 'Trocado em', sortable: true,variant: 'primary',
                   formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '') },  
                { key: 'internal_code_equipment', label: 'Equipamento', sortable: true },
                { key: 'tire_position_name', label: 'Posição', sortable: false },  
                { key: 'control_apoitement', label: 'KM', sortable: false },  
                { key: 'actions', label: 'Ações', variant: 'light' }

          ],
        }
    },
    computed: {
        user(){
            return this.$store.state.user
        },
        compan(){
            return this.$store.state.compan
        },
        rowsPayment() {
            return this.release_payments.length
        },
        rowsRecipe() {
            return this.release_recipes.length
        },
        rowsSupplyControl() {
            return this.supplycontrols.length
        },
        rowsTireMoviment() {
            return this.tiremoviments.length
        }
     },
    methods:{
        showMsgBoxCancelPayment(data) {
                this.boxCancel = ''
                this.$bvModal.msgBoxConfirm('Deseja excluir a despesa ?',{
                    title: 'Por favor confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if(this.boxCancel === true){
                       await this.removeReleasePayment(data)
                    }
                })

        },
        showMsgBoxCancelRecipe(data) {
                this.boxCancel = ''
                this.$bvModal.msgBoxConfirm('Deseja excluir a receita ?',{
                    title: 'Por favor confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if(this.boxCancel === true){
                       await this.removeReleaseRecipe(data)
                    }
                })

        },
        showMsgBoxCancelSupplyControl(data) {
                this.boxCancel = ''
                this.$bvModal.msgBoxConfirm('Deseja excluir o abastecimento ?',{
                    title: 'Por favor confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if(this.boxCancel === true){
                       await this.removeSupplyControl(data)
                    }
                })

        },
         showMsgBoxCancelTireMoviment(data) {
                this.boxCancel = ''
                this.$bvModal.msgBoxConfirm('Deseja excluir a troca de pneu ?',{
                    title: 'Por favor confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if(this.boxCancel === true){
                       await this.removeTireMoviment(data)
                    }
                })

        },
        async loadReleasesPayments() {

            const url = `${baseApiUrl}/releasessearchdate/${this.company_id}/?start_date=${this.start_date_payment}&end_date=${this.end_date_payment}&operation_id=${1}`
            await axios.get(url).then(res => {
                this.release_payments = res.data
                this.isBusyPayment = false
            })
            
        },
        async loadReleasesRecipes() {

            const url = `${baseApiUrl}/releasessearchdate/${this.company_id}/?start_date=${this.start_date_recipe}&end_date=${this.end_date_recipe}&operation_id=${2}`
            await axios.get(url).then(res => {
                this.release_recipes = res.data
                this.isBusyRecipe = false
            })
            
        },
        async loadSupplyControls() {

            const url = `${baseApiUrl}/supplycontrolssearchdate/${this.company_id}/?start_date=${this.start_date_supllycontrol}&end_date=${this.end_date_supplycontrol}`
            await axios.get(url).then(res => {
                this.supplycontrols = res.data
                this.isBusySupplyControl = false
            })
            
        },
        async loadTireMoviments() {

            const url = `${baseApiUrl}/tiremovimentssearchdate/${this.company_id}/?start_date=${this.start_date_supllycontrol}&end_date=${this.end_date_supplycontrol}`
            await axios.get(url).then(res => {
                this.tiremoviments = res.data
                this.isBusyTireMoviment = false
            })
            
        },
        toggleBusyPayment() {
            this.isBusyPayment = !this.isBusyPayment
        },
        toggleBusyRecipe() {
            this.isBusyRecipe = !this.isBusyRecipe
        }, 
        toggleBusySupplyControl() {
            this.isBusySupplyControl = !this.isBusySupplyControl
        },
        toggleBusyTireMoviment() {
            this.isBusyTireMoviment = !this.isBusyTireMoviment
        },
        async removeReleasePayment(release) {

            const id = release.id

            await axios.delete(`${baseApiUrl}/releases/${id}`)
            .then(() => {
                this.$toasted.global.defaultSuccess()
                this.loadReleasesPayments()
            })
            .catch(showError)
        },
        async removeReleaseRecipe(release) {

            const id = release.id

            await axios.delete(`${baseApiUrl}/releases/${id}`)
            .then(async () => {
                this.$toasted.global.defaultSuccess()
                this.loadReleasesRecipes()
            })
            .catch(showError)
        },
        async removeSupplyControl(release) {

            const id = release.id

            await axios.delete(`${baseApiUrl}/supplycontrols/${id}`)
            .then(async () => {
                this.$toasted.global.defaultSuccess()
                this.loadSupplyControls()
            })
            .catch(showError)
        },
    },
    mounted(){
        this.start_date_payment = moment().startOf('month').format('YYYY-MM-DD') 
        this.end_date_payment = moment().endOf('month').format('YYYY-MM-DD') 
        this.start_date_recipe = moment().startOf('month').format('YYYY-MM-DD') 
        this.end_date_recipe = moment().endOf('month').format('YYYY-MM-DD') 
        this.start_date_supllycontrol = moment().startOf('month').format('YYYY-MM-DD') 
        this.end_date_supplycontrol = moment().endOf('month').format('YYYY-MM-DD') 
        this.start_date_tiremoviment = moment().startOf('month').format('YYYY-MM-DD') 
        this.end_date_tiremoviment = moment().endOf('month').format('YYYY-MM-DD') 

        if(!this.compan)
        {
            this.company_id = this.user.company_default
        }else
        {
            this.company_id = this.compan.id
        }

    }
}
</script>

<style>
    .all-release {
            font-size: 0.7rem;
        }
    .all-release input {
            font-size: 0.7rem;
        }    
</style>
